import { cva } from 'class-variance-authority';

export const textVariants = cva([''], {
  variants: {
    size: {
      '2xs': ['text-2xs'],
      xs: ['text-xs'],
      sm: ['text-sm'],
      base: ['text-base'],
      lg: ['text-lg'],
      xl: ['text-xl'],
    },
    as: {
      span: ['font-normal'],
      p: ['font-normal'],
      strong: ['font-bold'],
      b: ['font-bold'],
    },
    textColor: {
      primary: ['#B877FF'],
      white: ['text-white'],
      black: ['text-black'],
    },
    decoration: {
      underline: ['underline'],
      lineThrough: ['line-through'],
    },
    shouldTruncate: {
      true: ['truncate'],
    },
  },
  defaultVariants: {
    size: 'base',
    as: 'span',
    textColor: 'primary',
  },
});
